
import React, { Component } from 'react';
import { connect } from 'react-redux';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, {LOG_LEVELS} from '../../utils/logger';
import { SDialog } from '@avalara/skylab-sdk/react';

const log = new Logger('CONFIRMATION_BOX', LOG_LEVELS.DEBUG);

class ConfirmationModal extends Component {
    
    constructor(props) {
        super(props);
        // Track if Yes was clicked to prevent onS-dismiss from triggering cancel
        this.yesClicked = false;
    }
    
    // Reset body overflow to ensure page scrollability is restored
    resetBodyOverflow() {
        document.body.style.overflow = '';
    }

    onYesClick(){
        // Set flag to prevent onS-dismiss from triggering cancel
        this.yesClicked = true;
        if (typeof this.props.onYesClickHandler === 'function') {
            this.props.onYesClickHandler();
        }
        this.resetBodyOverflow();
    }
    
    onCancelClick(){
        // Only call cancel handler if Yes wasn't clicked
        // (SDialog fires onS-dismiss when it closes, even after Yes)
        if (this.yesClicked) {
            this.yesClicked = false; // Reset for next time
            return;
        }
        this.props.onCancelClickHandler();
        this.resetBodyOverflow();
    }

    render() {
        return (
            <div>
                <SDialog
                    open={this.props.isModalPopupOpen}
                    onS-dismiss={() => this.onCancelClick()}
                    data-testid={this.props.dataTestId ? this.props.dataTestId +"-modal" : ""}
                >
                    <div slot="header">
                        <h1><LanguageStringResolver string={this.props.modelTitle}/></h1>
                    </div>
                    <div slot="body">
                        <p className="mb20" style={{ whiteSpace: 'pre-line' }}><LanguageStringResolver string={this.props.modelMessage}/></p>
                    </div>
                    <div slot="footer">
                        <button type="button" data-testid={this.props.dataTestId ? this.props.dataTestId +"-accept-btn" : ""} className="primary" onClick={() => this.onYesClick()}><LanguageStringResolver string='confirmationModal_ok'/></button>
                        <button type="button" data-testid={this.props.dataTestId ? this.props.dataTestId +"-cancel-btn" : ""} className="secondary" onClick={() => this.onCancelClick()}><LanguageStringResolver string='confirmationModal_cancel'/></button>
                    </div>
                </SDialog>
            </div>
        );
    }

    UNSAFE_componentWillMount() {
        log.log('ConfirmationBox: ', this.props);
    }

    componentDidUpdate(prevProps) {
        log.debug('componentDidUpdate()');
        // Reset body overflow when modal closes to prevent page from being stuck
        if (prevProps.isModalPopupOpen && !this.props.isModalPopupOpen) {
            this.resetBodyOverflow();
        }
    }

    componentWillUnmount() {
        // Ensure body overflow is reset when component unmounts
        this.resetBodyOverflow();
    }
}

// Which props do we want to inject, given the global state?
function mapStateToProps(state) {
    return {};
}


// Wrap the component to inject dispatch and state into it
export default connect(mapStateToProps)(ConfirmationModal);
